import { scrollTo } from 'lib/util'
import select from 'dom-select'
import on from 'dom-event'

const HEADER_SELECTOR = '.js-header'
const ANCHOR_LOCAL_STORAGE = 'scrollTarget'

export function scrollToContent (linkSelector, prevent = true) {
  const linkEls = select.all(linkSelector)
  if (linkEls) {
    linkEls.map((linkEl) => {
      on(linkEl, 'click', (e) => {
        if (prevent) {
          e.preventDefault()
        }
        const hash = e.target.hash
        const anchor = linkEl.getAttribute('data-anchor')
        if (hash) {
          if (!prevent) addLocalStorageScroll(hash)
          scrollToSelector(hash)
        } else if (anchor) {
          if (!prevent) addLocalStorageScroll(anchor)
          scrollToSelector(anchor)
        }
      })
    })
  }
}

export function scrollToSelector (target) {
  const contentEl = select(target)
  const offsetContent = select(HEADER_SELECTOR)
  if (contentEl && offsetContent) {
    scrollTo(contentEl, offsetContent.clientHeight - 5)
  }
}

export function addLocalStorageScroll (contentId) {
  return window.localStorage.setItem(ANCHOR_LOCAL_STORAGE, contentId)
}

export function getLocalStorageScroll (name) {
  return window.localStorage.getItem(name)
}

export function removeLocalStorageScroll (name) {
  return window.localStorage.removeItem(name)
}

export function scrollToByLocalStorage () {
  const contentId = getLocalStorageScroll(ANCHOR_LOCAL_STORAGE)
  if (contentId) {
    const headerHeight = select(HEADER_SELECTOR)
    scrollToSelector(contentId, headerHeight)
    removeLocalStorageScroll(ANCHOR_LOCAL_STORAGE)
  }
}
